module.exports = __webpack_public_path__ + "static/media/kunjungan-kemenkes.b3d87c53.jpeg";